/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerFindAllQueryResponse, TemplateSectionsControllerFindAllQueryParams, TemplateSectionsControllerFindAll401, TemplateSectionsControllerFindAll403 } from "../../models/checklistsController/TemplateSectionsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateSectionsControllerFindAll } from "../../clients/checklistsService/templateSectionsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateSectionsControllerFindAllQueryKey = (params: TemplateSectionsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-sections'
}, ...(params ? [params] : [])] as const;
export type TemplateSectionsControllerFindAllQueryKey = ReturnType<typeof templateSectionsControllerFindAllQueryKey>;
export function templateSectionsControllerFindAllQueryOptions(params?: TemplateSectionsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateSectionsControllerFindAllQueryKey(params);
  return queryOptions<TemplateSectionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindAll401 | TemplateSectionsControllerFindAll403>, TemplateSectionsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateSectionsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all checklist template sections
 * {@link /api/v1/checklist-template-sections}
 */
export function useTemplateSectionsControllerFindAll<TData = TemplateSectionsControllerFindAllQueryResponse, TQueryData = TemplateSectionsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateSectionsControllerFindAllQueryKey>(params?: TemplateSectionsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateSectionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindAll401 | TemplateSectionsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateSectionsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateSectionsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateSectionsControllerFindAll401 | TemplateSectionsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}